import React, { useContext, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";

// import { Ionicons } from '@expo/vector-icons';
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon, Foundation as FIcon } from '@expo/vector-icons';
import { ProductContext } from '../../contexts/product/Store';

import { AuthContext } from '../../contexts/auth/Store';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'

interface IProps {
    title?: string,
    count?: number,
    isLoading?: boolean
}

const ProductListHeader: React.FC<IProps> = function ({ title, isLoading, count }) {

    const auth = useContext(AuthContext)
    const buyer = auth.getUserData.buyerData

    const { product_state, product_dispatch } = useContext(ProductContext)

    const setProductView = (config: string) => {
        product_dispatch({ type: 'SET_PRODUCT_VIEW', payload: config })
    }

    return (
        <>
            <View style={styles.listMenu}>
                {
                    isLoading
                        ? <Text style={styles.listMenuText}>Fetching products</Text>
                        : <Text style={styles.listMenuText}>{title} ({count})</Text>
                }
                <TouchableOpacity style={styles.listMenuIcon} onPress={() => setProductView('grid')}>
                    <Icon
                        name='grid'
                        size={18}
                        color={product_state.product_view === 'grid' ? Colors.tintColor : Colors.shades._1}
                    />
                </TouchableOpacity>
                <TouchableOpacity style={styles.listMenuIcon} onPress={() => setProductView('list')}>
                    <Icon
                        name='menu'
                        size={24}
                        color={product_state.product_view === 'list' ? Colors.tintColor : Colors.shades._1}
                    />
                </TouchableOpacity>
            </View>
        </>
    )
}

export default ProductListHeader

ProductListHeader.defaultProps = {
    title: 'Products',
    count: 0,
    isLoading: true
}

const styles = StyleSheet.create({
    listMenu: {
        backgroundColor: Colors.whiteColor,
        paddingVertical: 10,
        paddingHorizontal: 16,
        flexDirection: 'row',
        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 1,
        borderStyle: 'solid'
    },
    listMenuText: {
        alignSelf: 'center',
        flexGrow: 1,
        width: 122,
        color: Colors.shades._7,
        ...FontStyles.size13,
        ...FontStyles.lh13,
        ...FontStyles.normal,
    },
    listMenuIcon: {
        alignSelf: 'center',
        padding: 3,
        marginLeft: 10,
    },
})